<template>
  <div class="three_contain_cla">
    <i v-if="!leftOpen"
       v-bind:style="{ 'background-color': getTheme}"
       @click.stop="leftOpen=!leftOpen"
       class="el-icon-d-arrow-right icon_cla"></i>
    <div class="col_cla"
         v-bind:class="{OpenCla: !leftOpen }">
      <!-- <i v-if="leftOpen"
         v-bind:style="{ 'background-color': getTheme}"
         @click.stop="leftOpen=!leftOpen"
         class="el-icon-d-arrow-left icon_cla"></i> -->
      <div v-if="leftOpen"
           class="el-card box-card is-always-shadow box-card">
        <div v-bind:style="{ 'background-color': getBreadTheme}"
             class="zkCard_head">
          <span>{{leftTitle}}</span>
          <i class="zk-icons zkiic_refresh1"
             @click.stop="refreshOrgData"
             style="float:right;cursor: pointer;"></i>
        </div>
        <div class="zkCard_body">
          <slot name="clo1"></slot>
        </div>
      </div>
    </div>
    <div style="display:flex;justify-content: flex-start;background:#fff;border-raduis:6px;height:inherit">
      <el-col :xs="12"
              :sm="12"
              :md="10"
              :lg="9"
              :xl="9"
              class="box-card">

        <div v-bind:style="{ 'background-color': getBreadTheme}"
             class="zkCard_head">
          <span>{{centerTitle}}</span>
        </div>
        <div class="zkCard_body">
          <slot name="clo2"></slot>
        </div>

      </el-col>
      <el-col :xs="12"
              :sm="12"
              :md="14"
              :lg="15"
              :xl="15"
              class="box-card"
              style="padding-top:0">

        <div v-bind:style="{ 'background-color': getBreadTheme}"
             class="zkCard_head">
          <!-- <span>{{rightTitle}}</span> -->
        </div>
        <div class="zkCard_body">
          <slot name="clo3"></slot>
        </div>

      </el-col>
    </div>
  </div>
</template>

<script>
import { getOrgStructure, getOrgType } from '@/services/enterpriseApi.js'
import { mapActions, mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import Vue from 'vue'

export default {
  data () {
    return {
      leftOpen: true,
      centerOpen: true,
      orgTypeList: [],
      orgType: '',
      orgData: []
    }
  },
  methods: {
    ...mapActions(['setOrgType']),
    refreshOrgData () {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('common.refresh'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.getDeptType()
      this.getOrgData()
    },
    getOrgData () {
      let params = {
        organizationTypeId: this.orgType
      }
      getOrgStructure(params)
        .then(data => {
          if (data.code === '00000000') {
            this.orgData = data.payload.results.organizationTree
            if (this.orgData && this.orgData.length > 0) {
              if (this.isSelectDefault) {
                Vue.nextTick(() => {
                  let id = this.orgData[0].id
                  this.$refs.deptTree.setCurrentKey(id)
                  let node = this.$refs.deptTree.getNode(id)
                  this.$emit('selectNode', node)
                })
              } else {
                this.$emit('selectNode', null)
              }
            }
          } else {
            this.orgData = []
          }
        })
        .catch(data => {
          this.errorMessage()
        }).finally(() => {
          if (this.loadingInstance) {
            setTimeout(() => {
              this.loadingInstance.close()
            }, 400)
          }
        })
    },

    getDeptType () {
      getOrgType()
        .then(data => {
          if (data.code === '00000000') {
            this.orgTypeList = data.payload.results.OrgTypes
            if (this.orgTypeList && this.orgTypeList.length > 0) {
              this.orgType = this.orgTypeList[0].id
              this.getOrgData()
              this.setOrgType(this.orgTypeList)
            }
          }
        })
        .catch(data => {
          this.orgTypeList = []
          this.errorMessage()
        }).finally(() => {
          if (this.loadingInstance) {
            setTimeout(() => {
              this.loadingInstance.close()
            }, 400)
          }
        })
    }
  },
  name: 'zkThreeColumn',
  computed: {
    ...mapGetters({
      getTheme: 'getTheme',
      getBreadTheme: 'getBreadTheme',
      getOrgType: 'getOrgType'
    })
  },
  props: {
    leftTitle: {
      type: String,
      default: ''
    },
    centerTitle: {
      type: String,
      default: ''
    },
    rightTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@CardHeadHeight: 40px;
.zkiic_refresh1:hover {
  color: #7ac143;
}
.three_contain_cla {
  margin-left: 0px;
  margin-right: 0px;
  height: 100%;
  .icon_cla {
    width: 40px;
    height: @CardHeadHeight;
    cursor: pointer;
    text-align: center;
    line-height: 48px;
    margin-right: 5px;
    float: left;
    border-radius: 5px;
    color: #fff;
  }
  .box-card {
    height: 100%;
    padding-top: @CardHeadHeight;
    box-sizing: border-box;
    position: relative;
    .zkCard_head {
      height: @CardHeadHeight;
      line-height: @CardHeadHeight;
      // border-bottom: 1px solid #ebeef5;
      box-sizing: border-box;
      position: absolute;
      padding: 0px 20px;
      top: 0px;
      width: 100%;
      color: #333; //#fff
    }
    .zkCard_body {
      padding: 15px;
      height: 100%;
      box-sizing: border-box;
      overflow: auto;
    }
  }

  .col_cla {
    position: relative;
    height: 100%;
    &:nth-child(1) {
      padding-left: 5px;
      padding-right: 10px;
    }
    .icon_cla {
      position: absolute;
      right: 10px;
      width: 40px;
      height: @CardHeadHeight - 1px;
      cursor: pointer;
      text-align: center;
      line-height: @CardHeadHeight;
      color: #fff;
      z-index: 1000;
      top: 1px;
    }
  }

  .col_cla:nth-of-type(1),
  .col_cla:nth-of-type(2) {
    float: left;
    width: 25%;
    height: 100%;
  }
  .col_cla:nth-of-type(2) {
    width: 30%;
  }
  .col_cla:nth-of-type(3) {
    overflow: hidden;
    height: 100%;
  }
}

@media only screen and (min-width: 901px) {
  .OpenCla {
    display: none;
    overflow: auto;
  }
}

@media only screen and (max-width: 900px) {
  .icon_cla {
    display: none;
  }
  .OpenCla {
    width: 100% !important;
    overflow: auto;
  }
  .col_cla {
    width: 100% !important;
    margin: 10px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/threeColumn.vue